import { Box } from "@mui/material";
import { t } from "i18next";
import { Dispatch, SetStateAction, useEffect } from "react";
import type { Swiper as SwiperType } from "swiper";
import { SweeperBullet } from "./SweeperBullet.style";
import { SweeperBulletContainerStyle } from "./SweeperStyles.style";
import { AccessibilityButtonStyle } from "../LucidIcon/LucidIcon.style";


type ISweeperBullet = {
  bullets: Record<string, unknown>[];
  swiperInstance: SwiperType | null;
  activeIndex: number;
  setActiveIndex: Dispatch<SetStateAction<number>>
}

export const SweeperBullets = ({ bullets, swiperInstance, activeIndex, setActiveIndex }: ISweeperBullet) => {

  function handleBulletSwipe(index: number) {
    setActiveIndex(index);
    swiperInstance && swiperInstance.slideTo(index, 0.1);
  }

  const isBulletActive = (index: number) => activeIndex === index ? "bullet-active" : "";

  useEffect(() => {
    swiperInstance?.activeIndex && setActiveIndex(swiperInstance?.activeIndex);
  }, [swiperInstance, setActiveIndex]);

  return (
    <Box role={ "list" }>
      <SweeperBulletContainerStyle role="listitem" aria-roledescription="carousel slides navigation bullets">
        { bullets.map((bullet, i) => {
          return (
            <AccessibilityButtonStyle
              key={ i }
              onClick={ () => handleBulletSwipe(i) }
              aria-label={ `${t("go_to") } ${bullet.title}` }
            >
              <SweeperBullet
                className={ isBulletActive(i) }
              />
            </AccessibilityButtonStyle>
          );
        }) }
      </SweeperBulletContainerStyle>
    </Box>
  );
};
